import React, { useEffect, useRef, useState } from "react";
import useStyles from "./styles";
import { FormGroup, InputBase, FormHelperText } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import MuiPhoneNumber, {} from "material-ui-phone-number";
import PostalCode from "../../PostalCode";
import ApmPayButton from '../ApmPayButton';

const Tamara = ({ currentPaymentSystem, formik, errorString }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const phoneInputRef = useRef();
  const [defaultCountry, setDefaultCountry] = useState(formik.values.country || 'AE'); 

  useEffect(() => {
    const {state} = phoneInputRef?.current;
    if (state && state.selectedCountry) {
      formik.setFieldValue('dialCode', state.selectedCountry.dialCode);
      formik.setFieldValue('dialCountryCode', state.selectedCountry.iso2.toUpperCase()); 
    }
  }, []);

  const handleChange = (value, country) => {
    if (!value || !country)
      return;

    formik.setFieldValue('phone', value);
    formik.setFieldValue('dialCode', country.dialCode);
    formik.setFieldValue('dialCountryCode', country.countryCode.toUpperCase());
  };

  return (
    <div className={classes.wrapper}>
      <FormGroup className={classes.cardForm}>
        <p className={`${classes.cardText} input_label_text`}>{t('Payer_phone')}</p>
        <MuiPhoneNumber 
            error={!!(formik.errors.phone)}
            className={classes.cardInput}
            name="phone"
            value={formik.values.phone || '+9710000000'}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            variant="outlined"
            placeholder={t('Payer_phone')}
            fullWidth
            defaultCountry={defaultCountry}
            disableAreaCodes={true}
            ref={phoneInputRef}
          />
        {
          formik.errors?.phone && (
            <FormHelperText className='error_text' error>{formik.errors?.phone}</FormHelperText>
          )
        }
      </FormGroup>
      <FormGroup className={classes.cardForm}>
        <p className={`${classes.cardText} input_label_text`}>{t('Payer_Address')}</p>
        <InputBase
          error={!!(formik.errors.address)}
          className={classes.cardInput}
          label={t('Payer_Address')}
          name="address"
          value={formik.values.address?.toUpperCase()}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          variant="outlined"
          placeholder={t('Payer_Address')}
          fullWidth
        />
        {
          formik.errors?.address && (
            <FormHelperText className='error_text' error>{formik.errors?.address}</FormHelperText>
          )
        }
      </FormGroup>
      <FormGroup className={classes.cardForm}>
        <p className={`${classes.cardText} input_label_text`}>{t('Payer_City')}</p>
        <InputBase
          error={!!(formik.errors.city)}
          className={classes.cardInput}
          label={t('Payer_City')}
          name="city"
          value={formik.values.city?.toUpperCase()}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          variant="outlined"
          placeholder={t('Payer_City')}
          fullWidth
        />
        {
          formik.errors?.city && (
            <FormHelperText className='error_text' error>{formik.errors?.city}</FormHelperText>
          )
        }
      </FormGroup>
      <FormGroup className={classes.cardForm}>
        <p className={`${classes.cardText} input_label_text`}>{t('Payer_state')}</p>
        <InputBase
          error={!!(formik.errors.state)}
          className={classes.cardInput}
          label={t('Payer_state')}
          name="state"
          value={formik.values.state?.toUpperCase()}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          variant="outlined"
          placeholder={t('Payer_state')}
          fullWidth
        />
        {
          formik.errors?.state && (
            <FormHelperText className='error_text' error>{formik.errors?.state}</FormHelperText>
          )
        }
      </FormGroup>
      <PostalCode formik={formik} className={`${classes.cardForm} input_label_text`} isApmShown={true} />
      <ApmPayButton currentPaymentSystem={currentPaymentSystem} errorString={errorString} />
    </div>
  )
};

export default Tamara
